import React from 'react';
import { useConnect } from '@lore/query-connect';
import useStewardshipFilter from '../../partners/useStewardshipFilter';
import { PayloadStates } from '@lore/utils';
import MetricLoader from '../MetricLoader';
import moment from 'moment-timezone';
import ComparisonMetric from '../ComparisonMetric';
import { offer_networkId, tags_educator } from '../../../utils/query-helpers';

export default function InvitedToOfferAndResponded(props) {
  const { network, schoolStart, schoolEnd, titleOnly } = props;

  const stewardshipFilter = useStewardshipFilter();

  const previousSchoolStart = moment(schoolStart).subtract(1, 'year').toISOString();

  const previousUsers = useConnect('user.find', {
    where: {
      eager: {
        $aggregations: [
          {
            type: 'count',
            alias: 'numberOfClaims',
            relation: 'claims',
            $where: {
              offerId: {
                $null: false
              },
              response: {
                $not: 'Pending'
              },
              ...offer_networkId(network),
              createdAt: {
                $lte: schoolStart,
                $gte: titleOnly ? undefined : previousSchoolStart
              }
            }
          }
        ],
        $where: {
          ...tags_educator(),
          $or: stewardshipFilter
        },
        $having: {
          numberOfClaims: {
            $gte: 1
          }
        }
      },
    },
    pagination: {
      pageSize: 1
    }
  });

  const newUsers = useConnect('user.find', {
    where: {
      eager: {
        $aggregations: [
          {
            type: 'count',
            alias: 'numberOfClaims',
            relation: 'claims',
            $where: {
              offerId: {
                $null: false
              },
              response: {
                $not: 'Pending'
              },
              ...offer_networkId(network),
              createdAt: {
                $lte: schoolEnd,
                $gte: schoolStart
              }
            }
          }
        ],
        $where: {
          ...tags_educator(),
          $or: stewardshipFilter
        },
        $having: {
          numberOfClaims: {
            $gte: 1
          }
        }
      },
    },
    pagination: {
      pageSize: 1
    }
  });

  if (
    previousUsers.state === PayloadStates.FETCHING ||
    newUsers.state === PayloadStates.FETCHING
  ) {
    return (
      <MetricLoader
        name="Responded to Offer Invite"
      />
    );
  }

  return (
    <ComparisonMetric
      name="Responded to Offer Invite"
      value={newUsers.meta.totalCount}
      previousValue={previousUsers.meta.totalCount}
      titleOnly={titleOnly}
    />
  );
}
